module.exports = __webpack_public_path__ + "static/media/geothermal.3857ad4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/geothermal.png
// module id = 262
// module chunks = 0